// Unified API exports - This replaces the old app/api.tsx file
// All API functions now use consistent authentication patterns

export {
  // Public API functions (no authentication required)
  trackAnalyticsEvent,
  getJobStatus,
  getJobStatusAuth,
  getLandingPageBySlug,
  getCareerPageBySlug,
  getCareerPageInfo,
  getLandingPageById,
  getSubscriptionRenewal,
  listPublishedJobLandingPages,
  searchPublicJobs,
  getJobOpenCheck,
  answerJobOpenCheck,
  getImage,
  healthCheck,

  // Authenticated API functions (requires authentication)
  submitJobLandingPage,
  getLandingPageJob,
  changeLandingPageOwnership,
  deleteLandingPage,
  listAllJobLandingPages,
  searchLandingPages,
  uploadImage,
  uploadCv,

  // New state machine action endpoints (preferred for state transitions)
  saveLandingPage,
  SaveConflictError,
  publishFreeAction,
  publishPaidAction,
  unpublishAction,
  resumeAdsAction,
  reactivateSubscriptionAction,
  generateSlidesAction,
  generateCvQuestionsAction,
  retryAction,

  // Bexio invoice billing actions
  activateBexioAction,
  cancelBexioAction,
  reactivateBexioAction,

  // User management API functions (requires authentication)
  getCurrentUserInfo,
  updateCurrentUserInfo,
  getAtsTypes,
  activateCareerPage,
  updateCareerPageSlug,

  // Stripe payment API functions (requires authentication)
  createCheckoutSession,
  createCustomerPortalSession,

  // Applicant email API functions (requires authentication)
  sendApplicantEmail,
  sendCvReminder,
  getApplicants,
  getLandingPageAnalytics,
  getCvFile,
  rejectApplicant,
  hireApplicant,
  unhireApplicant,
  keepApplicantForLater,
  restoreApplicant,
  sendInterviewInvite,
  updateApplicantNotes,

  // Email verification API functions (no authentication required)
  resendVerificationEmail,
  verifyEmail,

  // Contact purchase API functions (no authentication required)
  purchaseContact,

  // Admin API functions (requires admin authentication)
  getDailyReports,
  getB2BSnapshots,
  getB2BSearchQueries,
  getB2BAdPerformance,
  getB2BContentMetrics,
  getB2BBlogPosts,
  getB2BEntityDetail,
  getB2BIndexCoverage,
  getB2BSubscriptionRevenue,
  getB2BInsights,
  getB2BEventCompare,
  getB2BTrafficSources,
  getB2BConversionAttribution,
  getActivityStream,
  listEmails,
  getEmailById,
  getContactById,
  listAllApplicants,
  listAllContacts,
  getCallsheet,
  snoozeLandingPage,
  snoozeContact,

  // Server-side API functions (for API routes)
  searchLandingPagesServer,
  listAllJobLandingPagesServer,
  submitJobLandingPageServer,
  deleteLandingPageServer,
  uploadImageServer,
  // New state machine server-side functions
  saveLandingPageServer,
  publishFreeActionServer,
  publishPaidActionServer,
  unpublishActionServer,
  generateSlidesActionServer,
  retryActionServer,
  createCheckoutSessionServer,
  createCustomerPortalSessionServer,
  getCurrentUserInfoServer,
  updateCurrentUserInfoServer,
  sendApplicantEmailServer,
  sendApplicantEmailServerPublic,
  sendCvReminderServer,
  getApplicantsServer,
  getLandingPageJobServer,
  changeLandingPageOwnershipServer,
  resendVerificationEmailServer,
  verifyEmailServer,
  purchaseContactServer,
  listEmailsServer,
  getEmailByIdServer,
  getContactByIdServer,
  listAllApplicantsServer,
  listAllContactsServer,
  getCallsheetServer,
  snoozeLandingPageServer,
  snoozeContactServer,
} from "./api-functions";

// Re-export the API client for advanced usage
export { clientApi, serverApi, handleApiError } from "./api-client";

// Re-export publish utilities for unified payment flow
export { handlePaymentRedirect, defaultPaymentHandler } from "./publish-utils";
